export const getINRPayRate = (payments) => {
  // give the entire payments array from the placements db data and
  // it will calculate and return the INR payrate
  const rate = payments?.[payments?.length - 1]?.payRate?.subPercent 
    ? payments?.[payments?.length - 1]?.payRate?.payRatePerHour 
    : "-";
  return rate;
}

export const getUSPayRate = (payments) => {
  // give the entire payments array from the placements db data and
  // it will calculate and return the US payrate
  const lastPayment =
    payments?.[payments?.length - 1];
  const payRatePerHour = lastPayment?.payRate?.payRatePerHour || 0;
  const subPercent = lastPayment?.payRate?.subPercent || 0;
  const rate =
    subPercent > 0 ? (payRatePerHour * 100) / subPercent : payRatePerHour;
  // return isNaN(rate) ? 0 : rate?.toFixed(2) || 0;
  return  rate;
}